<div class="backdrop" fxLayout="column" fxLayoutAlign="center center">
    <div fxFlex fxLayout="column" fxLayoutGap="1vh" class="container" fxGrow="0">
        <span fxFlex>{{'Congratulations !' | translate}}</span>
        <span fxFlex>{{'Great work! You finished this scenario!' | translate}}</span>
        <span fxFlex>{{"Here's your summary scores for this storyline" | translate}}:</span>
        <div fxFlex class="points">{{'Total Points Earned' | translate}}: {{score}}</div>
        <button fxFlex fxGrow="0" (click)="gotoDashboard()" mat-raised-button color="primary">{{'Back to Home' |
            translate}}</button>
    </div>
</div>